import React from "react";

/**
 * Native `<select>` wrapped with the design-system field pattern.
 * @param {Object} props
 * @param {string} [props.label]
 * @param {Array<{value:string,label:string}>} [props.options]
 */
export function Select({ label, options = [], id, className = "", children, ...rest }) {
  return (
    <div className="ds-field">
      {label && <label className="ds-field-label" htmlFor={id}>{label}</label>}
      <select id={id} className={`ds-select ${className}`.trim()} {...rest}>
        {children ?? options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
}
